export class Config {
  static apiUrl = "https://acdc.vision.ee.ethz.ch/api";
  // static apiUrl = "http://localhost:10014/api";
}
